import Vue from "vue";
import { ChartPlugin, ColumnSeries, DataLabel, Tooltip, Legend, Category } from "@syncfusion/ej2-vue-charts";
Vue.use(ChartPlugin);
export default Vue.extend({
    props: {
        granularity: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            dataSource: {
                series: [],
                data: [],
                average: 0,
                color: null
            },
            marker: {
                dataLabel: { visible: true }
            },
            lastSearchData: null,
            primaryXAxis: {
                valueType: "Category",
                visible: false
            },
            primaryYAxis: {
                labelFormat: "n2"
            },
        };
    },
    provide: {
        chart: [ColumnSeries, Category, DataLabel, Tooltip, Legend]
    },
    computed: {
        averageString() {
            if (this.dataSource.average == undefined)
                return "";
            return this.dataSource.average.toFixed(2);
        },
        averageColor() {
            if (this.dataSource.color == undefined || this.dataSource.color == null)
                return "";
            return `background-color: ${this.dataSource.color}; border-color: ${this.dataSource.color}`;
        }
    },
    watch: {
        granularity() {
            if (this.lastSearchData != null) {
                const { startDate, endDate, employeeId, officeId } = this.lastSearchData;
                this.loadData(startDate, endDate, employeeId, officeId);
            }
        }
    },
    methods: {
        async loadData(startDate, endDate, employeeId, officeId) {
            this.lastSearchData = {
                startDate,
                endDate,
                employeeId,
                officeId
            };
            this.dataSource = {
                series: [],
                data: [],
                average: 0,
                color: null
            };
            this.$refs.chart.clearSeries();
            this.dataSource = await this.$store.dispatch("statistics/healthPathsDurationStandardDeviation", {
                startDate,
                endDate,
                employeeId,
                officeId,
                granularity: this.granularity
            });
        }
    }
});
